<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Eingangs-fragebogen</h1>

                <p class="h2">Vitadio hilft den Nutzenden, ihr Verhalten zu reflektieren und motiviert sie, ihren persönlichen Fokus im Programm zu wählen</p>
            </div>
            <div class="right-wrapper">
                <h2>Die Nutzenden haben unterschiedliche Prioritäten und Ziele</h2>
                <p class="text">Einige wollen ihr Gewicht reduzieren, andere wollen ihren Blutzucker senken und wieder andere wollen den Heißhunger auf Zucker loswerden. Vitadio unterstützt sie alle.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 7
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

